// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1M2P8","loaderWrapper":"styles_loaderWrapper__1gv7r","loaderWrapperHidden":"styles_loaderWrapperHidden__yhxOI","lds-ring":"styles_lds-ring__YZb21"};